import { registerCardTemplate } from "../../../common/common";
import { lazyTemplate } from "../../lazyTemplate";
import { generateIconProp } from "../../../common/icon-selector/IconEditor";

registerCardTemplate({
    id: 'column-bar-chart',
    name: 'Column Bar Chart',
    description: 'A column bar chart with multiple lines or bars.',
    template: lazyTemplate(() => import(/* webpackChunkName: "tpl-column-bar-chart" */ "./ColumnBarChartTemplate")),
    icon: generateIconProp('chartBar'),
    canDragDropFields: true,
    complexity: 'advanced',
    preLoader: 'bar-chart',
    expectedSchema: 'dictionary-array'
});
